import { userApiPost } from './apiPost'

export const searchProvider = userApiPost('search-provider')

export const searchClient = userApiPost('search-client')
